import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";

import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import DashboardHome from "./pages/DashboardHome";
import Settings from "./pages/Settings";
import ResetPassword from "./pages/ResetPassword";
import BecomePartner from "./pages/BecomePartner";
import Careers from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import HowItWorks from "./pages/HowItWorks";
import FAQs from "./pages/FAQs";
import Support from "./pages/Support";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ThankYou from "./pages/ThankYou";

import OrderManagement from "./pages/OrderManagement";
import Menu from "./pages/Menu";
import MenuUpload from "./pages/MenuUpload";

import AuthHeader from "./components/AuthHeader";
import Footer from "./components/Footer";
import Orders from "./pages/Orders";
import Analytics from "./pages/Analytics";
import Team from "./pages/Team";

const AddRestaurant = () => (
  <div className="min-h-screen flex items-center justify-center font-sans text-xl p-6">
    Add Your Restaurant Page (Coming Soon)
  </div>
);

const AppWrapper = () => {
  const location = useLocation();
  const path = location.pathname;

  const showHeader = !path.startsWith("/dashboard") && path !== "/";
  const footerPages = [
    "/terms",
    "/privacy",
    "/support",
    "/faq",
    "/careers",
    "/platform",
    "/become-partner",
  ];
  const showFooter = footerPages.includes(path);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {showHeader && <AuthHeader />}

      <Routes>
        {/* Public */}
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/become-partner" element={<BecomePartner />} />
        <Route path="/add-restaurant" element={<AddRestaurant />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:id" element={<JobDetail />} />
        <Route path="/platform" element={<HowItWorks />} />
        <Route path="/faq" element={<FAQs />} />
        <Route path="/support" element={<Support />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<DashboardHome />} />
        <Route path="/dashboard/orders" element={<OrderManagement />} />
        <Route path="/dashboard/orders/history" element={<Orders />} />
        <Route path="/dashboard/menu" element={<Menu />} />
        <Route path="/dashboard/menu/upload" element={<MenuUpload />} />
        <Route path="/dashboard/analytics" element={<Analytics />} />
        <Route path="/dashboard/team" element={<Team />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>

      {showFooter && <Footer />}
    </>
  );
};

const App = () => (
  <Router>
    <AppWrapper />
  </Router>
);

export default App;
